module.exports = new __parcel__URL__("hierarchy-tasks-with-background-dark.54880609.svg").toString();